import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/system/third/login/page',
    method: 'get',
    params
  })
}

export function getById(id) {
  return request({
    url: `/system/third/login/getById/${id}`,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: 'nav/login/',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/system/third/login/',
    method: 'put',
    data
  })
}

export function remove(ids) {
  return request({
    url: `/system/third/login/delete/${ids}`,
    method: 'delete'
  })
}

export function getMaxSort() {
  return request({
    url: '/system/third/login/getMaxSort',
    method: 'get'
  })
}

export function list() {
  return request({
    url: '/system/third/login/list',
    method: 'get'
  })
}
